(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["devoted-sale-banner"] && !Shopify.designMode) return;
  try {
    
function setupDevotedSale(){
document.querySelectorAll('[data-dv-sale]').forEach(function(bar){
const remaining=Date.parse(bar.dataset.ends)-Date.now();
if(remaining<=0){bar.hidden=true;return;}
setTimeout(function(){bar.hidden=true;},remaining);
const button=bar.querySelector('button');
if(!button.dataset.bound){button.dataset.bound='true';button.addEventListener('click',function(){const paused=bar.classList.toggle('is-paused');button.setAttribute('aria-pressed',String(paused));});}
});
}
setupDevotedSale();
document.addEventListener('shopify:section:load',setupDevotedSale);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
